import { render } from "./ConfirmarEnvio.vue?vue&type=template&id=c1cc71ae&scoped=true"
import script from "./ConfirmarEnvio.vue?vue&type=script&lang=js"
export * from "./ConfirmarEnvio.vue?vue&type=script&lang=js"

import "./ConfirmarEnvio.vue?vue&type=style&index=0&id=c1cc71ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cc71ae"]])

export default __exports__